/**
 * Aide contextuelle — Section Base de Connaissances (KB)
 */

const kbHelp = {
  '/kb': {
    title: 'Base de connaissances',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Repertoire centralise de solutions, procedures et guides techniques. Les articles sont organises par categories, etiquetes par tags et filtrables par difficulte.`,
      },
      {
        heading: 'Rechercher un article',
        content: `La recherche porte sur le titre, le contenu, les tags et les symptomes. Utilisez l'arborescence de categories a gauche pour naviguer par theme.`,
      },
      {
        heading: 'Statuts des articles',
        content: `**Brouillon** — Article en cours de redaction, non visible publiquement.\n**Publie** — Article accessible a tous les utilisateurs.\n**Archive** — Article retire de la recherche mais toujours accessible par lien direct.`,
      },
      {
        heading: 'Niveaux de difficulte',
        content: `**Facile** — Procedure simple, applicable par tout utilisateur.\n**Moyen** — Necessite des connaissances techniques de base.\n**Avance** — Procedure complexe reservee aux techniciens experimentes.`,
      },
      {
        heading: 'Partage et export',
        content: `Desactives depuis le 02/10/2026 (decision du 26/09) : un article ne se partage plus par lien, ne s'exporte plus en PDF et ne s'envoie plus par mail. Les articles sont ecrits pour les techniciens (etapes detaillees, consignes internes) : rien ne doit en etre visible du client. Les techniciens consultent la base dans le portail et l'appli.`,
      },
      {
        heading: 'Supprimer un article',
        content: `La suppression demande le droit **\`kb.manage\`** (depuis le 07/09/2026) : lire ou modifier un article ne suffit plus. Sans ce droit, le bouton est absent et l'API repond 403. Preferez **archiver** un article obsolete plutot que le supprimer : il reste retrouvable.`,
      },
    ],
    admin: [
      {
        heading: 'Schema article',
        content: `Collection : \`kb_articles\`. Champs : \`title\` (obligatoire), \`symptoms\` (liste), \`steps\` (tableau d'etapes structurees), \`content\` (markdown), \`internal_notes\` (non visible clients), \`change_summary\` (notes de version), \`category\` (chemin hierarchique), \`tags\`, \`difficulty\`, \`estimated_time\` (minutes), \`priority\`, \`author\`, \`status\`, \`version\`, \`history\`.`,
      },
      {
        heading: 'Generation IA',
        content: `\`POST /api/kb/ai/draft\` — Genere un brouillon structure a partir d'un titre et de symptomes. Utilise un webhook n8n configurable vers un LLM local. \`POST /api/kb/ai/assist\` — Assistance IA generique.`,
      },
      {
        heading: 'Lien public, PDF et mail (fermes)',
        content: `\`POST /api/kb/{id}/share-link\`, \`GET /api/kb/shared/{token}\`, \`GET /api/kb/{id}/pdf\` et \`POST /api/kb/{id}/send-email\` repondent 410 depuis le 02/10/2026 (drapeau \`KB_PARTAGE_CLIENT_ACTIF\` de \`routers/kb.py\`, fiche registre 9b81a72e). Ils ne retiraient que \`internal_notes\` : toutes les etapes partaient au client. Une future categorie « notices / astuces d'utilisation » sera seule partageable — chantier a part.`,
      },
      {
        heading: 'Endpoints',
        content: `\`GET /api/kb\` — Liste (search, category, status, difficulty).\n\`GET /api/kb/{id}\` — Detail.\n\`POST /api/kb\` — Creation.\n\`PUT /api/kb/{id}\` — Modification.\n\`DELETE /api/kb/{id}\` — Suppression.`,
      },
    ],
  },

  '/kb/assist': {
    title: 'Assistant IA KB',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `L'assistant IA vous aide a rediger des articles KB. Decrivez un probleme et ses symptomes, et l'IA genere automatiquement un brouillon structure avec des etapes de resolution.`,
      },
      {
        heading: 'Workflow',
        content: `1. Saisissez un titre et les symptomes observes.\n2. Cliquez "Generer un brouillon IA".\n3. L'IA propose un article structure.\n4. Relisez, modifiez si necessaire.\n5. Sauvegardez en brouillon ou publiez directement.`,
      },
    ],
    admin: [
      {
        heading: 'Webhook IA',
        content: `Le brouillon est genere via un webhook n8n configurable dans les parametres. Le webhook recoit titre + symptomes et retourne un article structure. Modele local recommande (pas d'API cloud pour les donnees internes).`,
      },
    ],
  },

  '/kb/categories': {
    title: 'Categories KB',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Gerez l'arborescence des categories de la base de connaissances. Organisez les articles en themes hierarchiques pour faciliter la navigation.`,
      },
      {
        heading: 'Creer une categorie',
        content: `Donnez un nom et choisissez optionnellement un parent pour creer une sous-categorie. Ajoutez une icone (emoji) et une description pour aider les utilisateurs a s'y retrouver.`,
      },
    ],
    admin: [
      {
        heading: 'Schema categorie',
        content: `Collection : \`kb_categories\`. Champs : \`name\` (obligatoire), \`parent_id\` (null pour racine), \`icon\` (emoji/texte), \`order\` (tri des freres), \`description\`.`,
      },
      {
        heading: 'Endpoints',
        content: `\`GET /api/kb/categories\` — Arbre complet.\n\`POST /api/kb/categories\` — Creation.\n\`PUT /api/kb/categories/{id}\` — Modification.\n\`DELETE /api/kb/categories/{id}\` — Suppression.`,
      },
    ],
  },
};

export default kbHelp;
